<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <v-layout wrap>
      <v-flex xs12 pb-0 pt-0 style="min-height: 60px">
        <v-expand-transition>
          <v-layout wrap v-show="selected.length < 1">
            <v-flex sl8 md6>
              <SelectCreditors
                :multiple="false"
                :clearable="false"
                :negotiation="true"
                :selected="selectedCreditor"
                @selectedCreditors="selectedCreditor = $event"
              >
              </SelectCreditors>
            </v-flex>
            <v-flex xs12 md6>
              <v-select
                box
                multiple
                clearable
                class="text-details-none"
                label="Tipo de abordagem"
                :items="approachesTypes"
                v-model="selectedApproachTypes"
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index <= 2">{{
                    index === 0 ? item : ", " + item
                  }}</span>
                  <span
                    v-if="index === 3"
                    style="padding-left: 5px"
                    class="grey--text caption"
                    >(+{{
                      selectedApproachTypes.length -
                      3 +
                      (selectedApproachTypes.length == 4
                        ? " outro)"
                        : " outros)")
                    }}</span
                  >
                </template>
              </v-select>
            </v-flex>
          </v-layout>
        </v-expand-transition>
        <v-expand-transition>
          <v-layout row wrap v-show="selected.length >= 1">
            <v-flex xs12 md6>
              <v-btn
                value="notify"
                color="accent"
                v-if="$route.path == '/strategies/production'"
                style="border-radius: 5px"
                @click="notifySelected(false)"
                >Notificar</v-btn
              >
              <v-btn
                value="publish"
                v-if="$route.path == '/strategies/planning'"
                color="accent"
                style="border-radius: 5px"
                @click="publishSelected"
                >Publicar</v-btn
              >
              <span class="font-weight-medium subheading" v-if="selected.length"
                >{{ selected.length }}
                {{
                  selected.length == 1 ? "Selecionada" : "Selecionadas"
                }}</span
              >
              <v-btn
                flat
                icon
                large
                class="my-0 py-0"
                color="accent"
                @click="deSelectAll"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 md6 class="text-sm-center text-md-right">
              <v-btn
                flat
                color="secondary"
                @click="
                  dialogMetrics = true;
                  multipleMetrics = true;
                "
              >
                <v-icon left>code</v-icon>Métricas
              </v-btn>
              <v-btn
                flat
                color="secondary"
                @click="
                  archiveMultiple = true;
                  updateStrategyData(true);
                "
              >
                <v-icon left>mdi-archive-arrow-down</v-icon>Arquivar
              </v-btn>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-btn
                      flat
                      color="secondary"
                      @click="
                        archiveMultiple = false;
                        dialogUpdate = true;
                      "
                    >
                      <v-icon left>mdi-calendar-range</v-icon>importação
                    </v-btn>
                  </span>
                </template>
                <span>Atualizar importação</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-expand-transition>
      </v-flex>
      <v-flex xs12>
        <v-tabs
          grow
          color="gray"
          style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 4px"
          v-model="tableTab"
        >
          <v-tab v-for="(tab, key) in publicTabs" :key="key">
            <p :class="`subheading font-weight-regular ${tab.color}--text`">
              {{ tab.name }}
            </p>
          </v-tab>
          <v-tabs-slider :color="publicTabs[tableTab].color"></v-tabs-slider>
          <v-tab-item v-for="(itemTab, k) in publicTabs" :key="k">
            <!-- :select-all="$route.path != '/strategies/archived'" -->
            <v-data-table
              select-all
              hide-actions
              item-key="id"
              :pagination.sync="allStrategies[itemTab.value].pagination"
              v-model="allStrategies[itemTab.value].selected"
              @input="changeTable($event)"
              :headers="headers"
              :items="allStrategies[itemTab.value].data"
            >
              <template v-slot:items="props">
                <!-- <v-checkbox v-if="$route.path != '/strategies/archived'" -->
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    v-model="props.selected"
                  ></v-checkbox>
                </td>
                <td>
                  <v-layout justify-start column wrap>
                    <span>
                      <v-tooltip
                        top
                        v-if="props.item.only_enrichment"
                        class="mr-1"
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon small color="blue" v-on="on"
                            >mdi-circle</v-icon
                          >
                        </template>
                        <span>Somente contatos enriquecidos</span>
                      </v-tooltip>
                      <v-tooltip
                        top
                        v-if="props.item.not_only_enrichment"
                        class="mr-1"
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon small color="red" v-on="on"
                            >mdi-circle</v-icon
                          >
                        </template>
                        <span>Somente contatos não enriquecidos</span>
                      </v-tooltip>
                      <v-tooltip v-if="props.item.name" top>
                        <template v-slot:activator="{ on }">
                          <div
                            v-on="on"
                            style="display: inline-grid; align-items: center"
                          >
                            <p class="mb-0 truncate">
                              #{{ props.item.id }} -
                              {{ props.item.name }}
                            </p>
                          </div>
                        </template>
                        <span>{{ props.item.name }}</span>
                      </v-tooltip>
                    </span>
                    <!-- abordagem -->
                    <span>
                      <v-tooltip v-if="props.item.approach" top>
                        <template v-slot:activator="{ on }">
                          <a
                            v-on="on"
                            style="display: inline-grid"
                            @click="goToApproach(props.item.approach)"
                          >
                            <p class="truncate" style="line-height: 19px">
                              <span
                                :class="`tag-approach-type small ${props.item.approach.type}`"
                                >{{ props.item.approach.type }}</span
                              >
                              {{ props.item.approach.name }}
                            </p>
                          </a>
                        </template>
                        <span>{{ props.item.approach.name }}</span>
                      </v-tooltip>
                      <v-tooltip top class="mr-1">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            small
                            v-if="props.item.approach.active == false"
                            color="orange"
                            v-on="on"
                            >mdi-alert-circle</v-icon
                          >
                        </template>
                        <span
                          >Estratégia utilizando uma abordagem desativada</span
                        >
                      </v-tooltip>
                    </span>
                  </v-layout>
                </td>
                <td>
                  <v-layout row justify-space-between>
                    <v-flex>
                      <p
                        class="text-xs-left"
                        style="font-size: 10px !important"
                      >
                        {{ props.item.segmentString }}
                      </p>
                      <p
                        class="text-xs-left"
                        style="font-size: 10px !important"
                      >
                        {{ props.item.segmentString2 }}
                      </p>
                      <p
                        class="text-xs-left"
                        style="font-size: 10px !important"
                      >
                        {{ props.item.segmentString3 }}
                      </p>
                      <p
                        class="text-xs-left"
                        style="font-size: 10px !important"
                      >
                        {{ props.item.segmentString4 }}
                      </p>
                    </v-flex>
                    <v-flex>
                      <v-menu
                        v-if="hasTag(props.item)"
                        :close-on-content-click="false"
                        :nudge-width="300"
                        offset-x
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            flat
                            icon
                            color="accent"
                            v-on="on"
                            style="margin: auto 0 auto 2px"
                          >
                            <v-icon>local_offer</v-icon>
                          </v-btn>
                        </template>
                        <v-card>
                          <v-list pa-0>
                            <v-list-tile v-if="props.item.tags_v2">
                              Negócio:
                              <v-chip
                                v-for="(
                                  item, index
                                ) in props.item.tags_v2.split(',')"
                                :key="index"
                                outline
                                small
                                color="dark-yellow"
                                >{{ item }}
                              </v-chip>
                            </v-list-tile>
                            <v-divider
                              v-if="
                                props.item.tags_v2 && props.item.contact_tags_v2
                              "
                            >
                            </v-divider>
                            <v-list-tile v-if="props.item.contact_tags_v2">
                              Contato:
                              <v-chip
                                v-for="(
                                  item, index
                                ) in props.item.contact_tags_v2.split(',')"
                                :key="index"
                                outline
                                small
                                color="blue"
                              >
                                {{ item }}
                              </v-chip>
                            </v-list-tile>
                            <v-list-tile v-if="props.item.customer_tag">
                              Cliente:
                              <v-chip
                                v-for="(
                                  item, index
                                ) in props.item.customer_tag.split(',')"
                                :key="index"
                                outline
                                small
                                color="green"
                              >
                                {{ item }}
                              </v-chip>
                            </v-list-tile>
                          </v-list>
                        </v-card>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </td>
                <td>
                  <p
                    style="white-space: nowrap"
                    v-if="
                      props.item.contact_min_final_score &&
                      props.item.contact_max_final_score
                    "
                  >
                    <strong class="mr-1">{{
                      props.item.contact_min_final_score
                    }}</strong>
                    <small>Até </small>
                    <strong class="mr-1">
                      {{ props.item.contact_max_final_score }}</strong
                    >
                  </p>
                  <p v-else-if="props.item.contact_max_final_score">
                    <small>Até</small>
                    <strong class="mr-1">
                      {{ props.item.contact_max_final_score }}</strong
                    >
                  </p>

                  <p />
                  <p
                    v-if="
                      props.item.contact_min_final_score &&
                      !props.item.contact_max_final_score
                    "
                  >
                    <small>À partir de</small>
                    <strong class="mr-1">
                      {{ props.item.contact_min_final_score }}</strong
                    >
                  </p>

                  <p />
                </td>
                <td v-if="currentTab != 'IMPORTED'">
                  <p
                    style="white-space: nowrap"
                    v-if="
                      props.item.min_notifications &&
                      props.item.max_notifications
                    "
                  >
                    <strong class="mr-1">{{
                      props.item.min_notifications
                    }}</strong>
                    <small> até </small>
                    <strong class="mr-1">{{
                      props.item.max_notifications
                    }}</strong>
                    <small>
                      {{
                        props.item.max_notifications == 1
                          ? "notificação"
                          : "notificações"
                      }}</small
                    >
                  </p>
                  <p v-else-if="props.item.max_notifications">
                    <small> Até </small>
                    <strong class="mr-1">
                      {{ props.item.max_notifications }}</strong
                    >
                    <small>
                      {{
                        props.item.max_notifications == 1
                          ? "notificação"
                          : "notificações"
                      }}</small
                    >
                  </p>

                  <p />
                  <p
                    v-if="
                      props.item.min_notifications &&
                      !props.item.max_notifications
                    "
                  >
                    <small> À partir de </small>
                    <strong class="mr-1">
                      {{ props.item.min_notifications }}</strong
                    >
                    <small>
                      {{
                        props.item.min_notifications == 1
                          ? "notificação"
                          : "notificações"
                      }}</small
                    >
                  </p>

                  <p />
                  <p
                    v-if="
                      props.item.days_to_wait || props.item.days_to_wait == 0
                    "
                    style="white-space: nowrap"
                  >
                    <strong class="mr-1">{{ props.item.days_to_wait }}</strong>
                    <small
                      >{{ props.item.days_to_wait == 1 ? "dia" : "dias" }} de
                      espera</small
                    >
                  </p>
                </td>
                <td>
                  <div style="display: inline-flex">
                    <p
                      v-if="props.item.last_notification_count"
                      style="white-space: nowrap"
                    >
                      <strong>{{
                        props.item.last_notification_count | numeral("0,0")
                      }}</strong>
                      <small v-if="props.item.limit"
                        >/{{ props.item.limit | numeral("0,0") }}</small
                      >
                    </p>
                    <v-tooltip
                      top
                      class="ml-1"
                      v-if="checkNotificationToday(props.item.last_notified_at)"
                    >
                      <template v-slot:activator="{ on }">
                        <v-icon left color="green" small v-on="on"
                          >call_made</v-icon
                        >
                      </template>
                      <span>Disparado hoje</span>
                    </v-tooltip>
                  </div>
                  <p style="white-space: nowrap">
                    {{
                      props.item.last_notification_user
                        ? props.item.last_notification_user.split(" ")[0] + ", "
                        : ""
                    }}
                    <small v-if="props.item.last_notified_at">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <span v-on="on">{{
                            props.item.last_notified_at | formatDateAgo
                          }}</span>
                        </template>
                        <span
                          >Gerado em
                          {{
                            props.item.last_notified_at | formatDateTime
                          }}</span
                        >
                      </v-tooltip>
                    </small>
                  </p>
                </td>
                <td>
                  <p>
                    {{ props.item.last_import_since | formatDateUTC }}
                  </p>
                </td>
                <td>
                  <p>
                    {{ props.item.updated_at | formatDateTime }}
                  </p>
                </td>
                <td>
                  <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile
                        v-if="$route.path == '/strategies/planning'"
                        @click="clickItemAction(props.item, 'publish')"
                      >
                        <v-list-tile-title>Publicar</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        v-if="$route.path == '/strategies/production'"
                        @click="clickItemAction(props.item, 'notify')"
                      >
                        <v-list-tile-title>Notificar</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="clickItemAction(props.item, 'edit')">
                        <v-list-tile-title>Editar</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="openDialogMetrics(props.item)">
                        <v-list-tile-title>Métricas</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        @click="clickItemAction(props.item, 'clone')"
                      >
                        <v-list-tile-title>Clonar</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        @click="clickItemAction(props.item, 'updateStatus')"
                      >
                        <v-list-tile-title> Arquivar </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </td>
              </template>
              <template v-slot:no-data>
                <v-container
                  fluid
                  fill-height
                  style="background-color: rgba(255, 255, 255, 0.5)"
                >
                  <v-layout justify-center align-center>
                    <v-progress-circular
                      v-if="loading"
                      indeterminate
                      color="primary"
                    >
                    </v-progress-circular>
                    <span v-else
                      >Nenhuma estratégia sob demanda encontrada.</span
                    >
                  </v-layout>
                </v-container>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="dialogUpdate"
      min-height="500px"
      max-width="500px"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-layout justify-center>
          <v-card-title class="headline">
            <strong v-if="archiveMultiple" class="headline"
              >Arquivar estratégias</strong
            >
            <strong v-else class="headline">Atualizar importação</strong>
          </v-card-title>
        </v-layout>
        <v-divider></v-divider>
        <v-layout
          column
          :style="
            $vuetify.breakpoint.smAndDown
              ? 'min-height: 70vh'
              : 'min-height: 40vh'
          "
        >
          <v-flex md12 style="overflow: auto">
            <v-tabs id="tab-wrapper" v-model="tabs">
              <v-tab v-for="n in 2" :key="n" ripple>Item {{ n }}</v-tab>
              <v-tab-item height="20vh">
                <template>
                  <div cols="12" sm="6" class="my-2 px-1">
                    <v-date-picker
                      color="primary"
                      locale="pt-br"
                      no-title
                      class="elevation-0"
                      style="color: white"
                      light
                      ref="picker"
                      v-model="last_import_since"
                      scrollable
                      full-width
                      actions
                    ></v-date-picker>
                  </div>
                </template>
              </v-tab-item>
              <v-tab-item height="20vh">
                <v-layout
                  column
                  wrap
                  justify-center
                  align-center
                  class="mx-2 my-3 pa-3"
                  height="100%"
                >
                  <p
                    v-if="archiveMultiple"
                    class="title font-weight-regular mt-3"
                  >
                    Deseja arquivar?
                  </p>
                  <p v-else class="title font-weight-regular mt-3">
                    Deseja atualizar data de importação?
                  </p>
                  <p v-if="!archiveMultiple" class="font-weight-bold mt-3">
                    {{ last_import_sinceFormatted }}
                  </p>
                  <p v-if="archiveMultiple" class="mt-3">
                    <strong>{{ selected.length }}</strong>
                    {{
                      selected.length > 1
                        ? "estratégias serão arquivadas."
                        : "estratégia será arquivada."
                    }}
                  </p>
                  <p v-else class="mt-3">
                    <strong>{{ selected.length }}</strong>
                    {{
                      selected.length > 1
                        ? "estratégias serão atualizadas."
                        : "estratégia será atualizada."
                    }}
                  </p>
                  <p>
                    <strong>{{ creditorsImportDate.size }}</strong>
                    {{ creditorsImportDate.size > 1 ? "credores" : "credor" }}
                  </p>
                </v-layout>
              </v-tab-item>
            </v-tabs>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="dialogUpdate = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="accent"
            text
            v-if="tabs === 0"
            @click="updateStrategyData(true)"
            >Continuar</v-btn
          >
          <v-btn
            color="accent"
            text
            v-if="tabs === 1"
            @click="updateStrategyData()"
            >Confirmar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMetrics" max-width="450">
      <v-card>
        <v-card-title class="mb-0 pb-0">
          <v-layout column>
            <p class="headline">Métricas</p>
            <p v-if="!multipleMetrics">#{{ metrics.id }} {{ metrics.name }}</p>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout wrap>
              <v-flex sl12 md6>
                <v-layout wrap>
                  <v-flex xs12>
                    <h6 class="subheading">Interesse</h6>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      box
                      suffix="%"
                      label="Ruim"
                      type="number"
                      autocomplete="off"
                      class="text-details-none"
                      name="indicator_bad_accessed"
                      v-model="formattedBadAccessed"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      class="text-details-none"
                      suffix="%"
                      label="Bom"
                      type="number"
                      autocomplete="off"
                      name="indicator_good_accessed"
                      box
                      v-model="formattedGoodAccessed"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sl12 md6>
                <v-layout wrap>
                  <v-flex xs12>
                    <h6 class="subheading">Conversão</h6>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      suffix="%"
                      class="text-details-none"
                      label="Ruim"
                      type="number"
                      autocomplete="off"
                      name="indicator_bad_interest"
                      box
                      v-model="formattedBadInterest"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      suffix="%"
                      class="text-details-none"
                      label="Bom"
                      type="number"
                      autocomplete="off"
                      name="indicator_good_interest"
                      box
                      v-model="formattedGoodInterest"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sl12 md6>
                <v-layout wrap>
                  <v-flex xs12>
                    <h6 class="subheading">Implantação</h6>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      class="text-details-none"
                      suffix="%"
                      label="Ruim"
                      type="number"
                      autocomplete="off"
                      name="indicator_bad_implantation"
                      box
                      v-model="formattedBadImplantation"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      class="text-details-none"
                      suffix="%"
                      label="Bom"
                      type="number"
                      autocomplete="off"
                      name="indicator_good_implantation"
                      box
                      v-model="formattedGoodImplantation"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sl12 md6>
                <v-layout wrap>
                  <v-flex xs12>
                    <h6 class="subheading">CPP</h6>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      suffix="R$"
                      class="text-details-none"
                      label="Ruim"
                      type="number"
                      autocomplete="off"
                      name="indicator_bad_cpp"
                      box
                      v-model="metrics.indicator_bad_cpp"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      suffix="R$"
                      class="text-details-none"
                      label="Bom"
                      type="number"
                      autocomplete="off"
                      name="indicator_good_cpp"
                      box
                      v-model="metrics.indicator_good_cpp"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="dialogMetrics = false"
            >Fechar</v-btn
          >
          <v-btn color="blue darken-1" flat="flat" @click="saveMetrics">{{
            multipleMetrics ? "APLICAR" : "SALVAR"
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ModelNewStrategy
      @fetched="updateStrategies($event)"
      :segments="segments"
      :campaigns="campaigns"
      :creditor_profiles="creditor_profiles"
      :creditoProfilesFilter="creditoProfilesFilter"
      :tags_v2="tags_v2"
      :tagsFilter="tagsFilter"
      :contact_tags_v2="contact_tags_v2"
      :customer_tag="customer_tag"
      :contactTagsFilter="contactTagsFilter"
      :customerTagsFilter="customerTagsFilter"
      :approaches="approaches"
    ></ModelNewStrategy>
    <v-dialog
      v-model="dialogMultipleMetrics"
      hide-overlay
      persistent
      width="300"
    >
      <v-card color="primary" dark>
        <v-card-text>
          Salvando as alterações
          <v-progress-linear
            v-model="countMetrics"
            :buffer-value="arrayMetrics.length"
            buffer
            color="white"
            class="mb-0"
          ></v-progress-linear>
          {{ countMetrics }} de {{ arrayMetrics.length }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import Cookies from "js-cookie";
import store from "@/store";
import numeral from "numeral";
import { EventBus } from "@/services/event-bus";
import headers from "./headers";
import strategyService from "@/services/strategy";
import approachService from "@/services/approach";
import strategyPublic from "@/utils/strategy-public";
import SelectCreditors from "@/components/creditor/SelectCreditors";
import segmentService from "@/services/consolidation-tree/segments";
import campaignService from "@/services/consolidation-tree/campaign";
import dealTagsService from "@/services/consolidation-tree/deal-tags";
import contactTagService from "@/services/consolidation-tree/contact-tags";
import customerTagService from "@/services/consolidation-tree/customer-tag";
import ModelNewStrategy from "@/views/strategy/components/ModelNewStrategy";
import creditorProfileService from "@/services/consolidation-tree/creditor-profile";

export default {
  components: {
    SelectCreditors,
    ModelNewStrategy,
  },
  mounted() {
    if (this.strategy_id) {
      EventBus.$emit("edit", { id: this.strategy_id });
    }
  },
  created() {
    this.publicTabs = strategyPublic.strategyPublic;
    this.query = this.$route.query;

    this.headers = headers.strategy;

    this.strategy_id = this.query.strategy_id;
    if (Object.keys(this.query).length == 0)
      this.query = store.getters.getManualStrategy;

    if (this.query.types) {
      this.query.types.split(",").forEach((id) => {
        this.selectedApproachTypes.push(id);
      });
    }

    if (this.query.creditors) {
      this.query.creditors.split(",").forEach((id) => {
        this.selectedCreditor = parseInt(id);
      });
    }
    if (typeof this.query !== "undefined") {
      if (this.query.creditor)
        this.selectedCreditor = parseInt(this.query.creditor);

      if (this.query.approachTypes) {
        let _types = this.query.approachTypes.split(",");
        this.selectedApproachTypes = [];
        _types.forEach((p) => {
          this.approachesTypes.forEach((el) => {
            if (p == el) this.selectedApproachTypes.push(el);
          });
        });
      }
      if (this.query.tableTab) this.tableTab = parseInt(this.query.tableTab);
      else this.tableTab = 0;
    }
    this.addfilters();
    this.getDataApi();
    this.fetchDialogData();
    setTimeout(() => (this.doneFetching = true), 1000);
  },
  data() {
    return {
      loading: false,
      strategy_id: null,
      archiveMultiple: false,
      dialogUpdate: false,
      multipleMetrics: false,
      doneFetching: false,
      dialogMetrics: false,
      dialogMultipleMetrics: false,
      tabs: 0,
      tableTab: null,
      currentTab: null,
      countMetrics: 0,
      selectedCreditor: 1,
      selected: [],
      publicTabs: [],
      segments: [],
      SegmentFilter: [],
      campaigns: [],
      creditor_profiles: [],
      creditoProfilesFilter: [],
      tags_v2: [],
      tagsFilter: [],
      contact_tags_v2: [],
      contactTagsFilter: [],
      customer_tag: [],
      customerTagsFilter: [],
      approaches: [],
      arrayMetrics: [],
      rowsPerPageItems: [999],
      selectedApproachTypes: [],
      headers: [],
      approachesTypes: ["SMS", "PUSH"],
      query: {},
      metrics: {
        indicator_bad_accessed: 0.015,
        indicator_good_accessed: 0.03,
        indicator_bad_implantation: 0.85,
        indicator_good_implantation: 0.9,
        indicator_bad_cpp: 18,
        indicator_good_cpp: 12,
        indicator_good_interest: 0.15,
        indicator_bad_interest: 0.1,
      },
      allStrategies: {
        IMPORTED: {
          fetched: false,
          pagination: {},
          data: [],
          selected: [],
        },
        UNCHECKED: {
          fetched: false,
          pagination: {},
          data: [],
          selected: [],
        },
        CHECKED: {
          fetched: false,
          pagination: {},
          data: [],
          selected: [],
        },
        LOCATED: {
          fetched: false,
          pagination: {},
          data: [],
          selected: [],
        },
      },
      creditorsImportDate: new Set(),
      last_import_since: new Date().toISOString().substr(0, 10),
    };
  },
  computed: {
    formattedBadAccessed: {
      get: function () {
        let value = this.metrics.indicator_bad_accessed;
        value = value ? value * 100 : null;
        value = Math.round(value * 100) / 100;
        return value;
      },
      set: function (newValue) {
        if (newValue) {
          newValue = parseFloat((parseFloat(newValue) / 100).toFixed(4));
          this.metrics.indicator_bad_accessed = newValue;
        } else this.metrics.indicator_bad_accessed = null;
      },
    },
    formattedGoodAccessed: {
      get: function () {
        let value = this.metrics.indicator_good_accessed;
        value = value ? value * 100 : null;
        value = Math.round(value * 100) / 100;
        return value;
      },
      set: function (newValue) {
        if (newValue) {
          newValue = parseFloat((parseFloat(newValue) / 100).toFixed(4));
          this.metrics.indicator_good_accessed = newValue;
        } else this.metrics.indicator_good_accessed = null;
      },
    },
    formattedBadInterest: {
      get: function () {
        return this.metrics.indicator_bad_interest
          ? this.metrics.indicator_bad_interest * 100
          : null;
      },
      set: function (newValue) {
        if (newValue) this.metrics.indicator_bad_interest = newValue / 100;
        else this.metrics.indicator_bad_interest = null;
      },
    },
    formattedGoodInterest: {
      get: function () {
        let value = this.metrics.indicator_good_interest;
        return value ? value * 100 : null;
      },
      set: function (newValue) {
        if (newValue) this.metrics.indicator_good_interest = newValue / 100;
        else this.metrics.indicator_good_interest = null;
      },
    },
    formattedBadImplantation: {
      get: function () {
        return this.metrics.indicator_bad_implantation
          ? this.metrics.indicator_bad_implantation * 100
          : null;
      },
      set: function (newValue) {
        if (newValue) this.metrics.indicator_bad_implantation = newValue / 100;
        else this.metrics.indicator_bad_implantation = null;
      },
    },
    formattedGoodImplantation: {
      get: function () {
        let value = this.metrics.indicator_good_implantation;
        return value ? value * 100 : null;
      },
      set: function (newValue) {
        if (newValue) this.metrics.indicator_good_implantation = newValue / 100;
        else this.metrics.indicator_good_implantation = null;
      },
    },
    last_import_sinceFormatted(data) {
      return this.last_import_since
        ? moment
            .utc(new Date(this.last_import_since).toUTCString())
            .format("DD/MM/YYYY")
        : "";
    },
  },
  watch: {
    // "$route.path": function (id) {
    //     this.fetchAll();
    // },
    dialogUpdate() {
      if (!this.dialogUpdate) {
        this.tabs = 0;
      }
    },
    selectedCreditor() {
      if (this.doneFetching) {
        this.fetchAll();
        this.fetchDialogData();
      }
    },
    selectedApproachTypes() {
      if (this.doneFetching) this.fetchAll();
    },
    tableTab() {
      let currentTab = this.publicTabs[this.tableTab].value;
      this.currentTab = currentTab;
      if (currentTab == "IMPORTED") this.headers = headers.strategyImported;
      else if (currentTab == "LOCATED") this.headers = headers.strategyLocated;
      else this.headers = headers.strategy;
      this.addfilters();
      if (!this.allStrategies[currentTab].fetched) this.getDataApi();
    },
    dialogMetrics() {
      if (!this.dialogMetrics)
        this.metrics = {
          indicator_bad_accessed: 0.015,
          indicator_good_accessed: 0.03,
          indicator_bad_implantation: 0.85,
          indicator_good_implantation: 0.9,
          indicator_good_cpp: 12,
          indicator_bad_cpp: 18,
          indicator_bad_interest: 0.1,
          indicator_good_interest: 0.15,
        };
    },
  },
  methods: {
    async updateStrategyStatus(strategy) {
      strategy.active = !strategy.active;
      let vm = this;
      let currentTab = vm.publicTabs[vm.tableTab].value;
      let message = "";
      await strategyService
        .save(strategy)
        .then(async (res) => {
          message = `Estratégia ${strategy.name} arquivada!`;
          this.$store.commit("showSnackbar", {
            message,
            important: true,
          });
          if (res == undefined) {
            this.$store.commit("showSnackbar", "Houve um erro ao salvar");
            return console.error("houve um erro");
          }
          if (strategy.selected) vm.setSelected(strategy);
          vm.allStrategies[currentTab].data = await vm.removeFromList(
            strategy.id,
            vm.allStrategies[currentTab].data
          );
        })
        .catch((error) => {
          this.$store.commit("showSnackbar", "Houve um erro ao salvar");
          console.error("Houve um erro", error);
        });
    },
    async fetchDialogData() {
      if (this.selectedCreditor) {
        await this.getSegments();
        await this.getCampaing();
        await this.getCreditorProfile();
        await this.getDealTags();
        await this.getContactTagsV2();
        await this.getCustomerTagsV2();
        await this.searchApproach();
      }
    },

    async getSegments() {
      this.segments = await segmentService.list({
        params: { creditor_id: this.$route.query.creditor },
      });

      if (this.segments.length > 0) {
        this.SegmentFilter = [{ header: "Inclusão" }];

        this.segments.forEach((seg) => {
          if (seg[0] != "-") {
            this.SegmentFilter.push({ name: seg });
          }
        });

        this.SegmentFilter.push({ header: "Exclusão" });

        this.segments.forEach((seg) => {
          if (seg[0] == "-") {
            this.SegmentFilter.push({ name: seg });
          }
        });

        this.SegmentFilter.unshift("Sem-segmento");
      } else {
        this.segments = ["Sem-segmento"];
      }
    },

    async getCampaing() {
      let campaigns = await campaignService.list({
        params: { creditor_id: this.$route.query.creditor },
      });
      this.campaigns = campaigns.filter((c) => c.key).map((c) => c.key);
      this.campaigns.unshift("Sem-campanha");
    },

    async getCreditorProfile() {
      this.creditor_profiles = await creditorProfileService.list({
        params: { creditor_id: this.$route.query.creditor },
      });
      this.creditor_profiles = this.creditor_profiles.filter(function (
        creditor_profiles
      ) {
        return creditor_profiles;
      });

      if (this.creditor_profiles.length > 0) {
        this.creditoProfilesFilter = [{ header: "Inclusão" }];

        this.creditor_profiles.forEach((cred) => {
          if (cred[0] != "-") {
            this.creditoProfilesFilter.push({ name: cred });
          }
        });

        this.creditoProfilesFilter.push({ header: "Exclusão" });

        this.creditor_profiles.forEach((cred) => {
          if (cred[0] == "-") {
            this.creditoProfilesFilter.push({ name: cred });
          }
        });

        this.creditoProfilesFilter.unshift("Sem-perfil");
      } else {
        this.creditor_profiles.unshift("Sem-perfil");
      }
    },

    async getDealTags() {
      this.tags_v2 = await dealTagsService.list({
        params: { creditor_id: this.$route.query.creditor },
      });
      this.tags_v2 = this.tags_v2.filter(function (tags_v2) {
        return tags_v2;
      });

      if (this.tags_v2.length > 0) {
        this.tagsFilter = [{ header: "Inclusão" }];

        this.tags_v2.forEach((tag) => {
          if (tag[0] != "-") {
            this.tagsFilter.push({ name: tag });
          }
        });

        this.tagsFilter.push({ header: "Exclusão" });

        this.tags_v2.forEach((tag) => {
          if (tag[0] == "-") {
            this.tagsFilter.push({ name: tag });
          }
        });

        this.tagsFilter.unshift("Sem-tags");
      } else {
        this.tags_v2 = ["Sem-tags"];
      }
    },

    async getContactTagsV2() {
      this.contact_tags_v2 = await contactTagService.list({
        params: { creditor_id: this.$route.query.creditor },
      });
      this.contact_tags_v2 = this.contact_tags_v2.filter(function (tag) {
        return tag;
      });

      if (this.contact_tags_v2.length > 0) {
        this.contactTagsFilter = [{ header: "Inclusão" }];

        this.contact_tags_v2.forEach((tag) => {
          if (tag[0] != "-") {
            this.contactTagsFilter.push({ name: tag });
          }
        });

        this.contactTagsFilter.push({ header: "Exclusão" });

        this.contact_tags_v2.forEach((tag) => {
          if (tag[0] == "-") {
            this.contactTagsFilter.push({ name: tag });
          }
        });

        this.contactTagsFilter.unshift("Sem-tags");
      } else {
        this.contact_tags_v2 = ["Sem-tags"];
      }
    },

    async getCustomerTagsV2() {
      this.customer_tag = await customerTagService.getCustomerTags(this.$route.query.creditor);

      if (this.customer_tag.length > 0) {
        this.customerTagsFilter = [{ header: "Inclusão" }];

        this.customer_tag.forEach((tag) => {
          if (tag[0] != "-") {
            this.customerTagsFilter.push({ name: tag });
          }
        });

        this.customerTagsFilter.push({ header: "Exclusão" });

        this.customer_tag.forEach((tag) => {
          if (tag[0] == "-") {
            this.customerTagsFilter.push({ name: tag });
          }
        });

        this.customerTagsFilter.unshift("Sem-tags");
      } else {
        this.customer_tag = ["Sem-tags"];
      }
    },

    searchApproach() {
      const creditor_id = this.$route.query.creditor;
      if (typeof creditor_id === "undefined") {
        this.approaches = [];
      } else {
        approachService.listAll(creditor_id, true).then(async (res) => {
          this.approaches = res.objects;
        });
      }
    },

    async removeFromList(id, list) {
      return list.filter(function (e) {
        return e.id !== id;
      });
    },
    async updateStrategyData(checkData = false) {
      let vm = this;
      let updated = 0;
      let error = 0;
      let currentTab = vm.publicTabs[vm.tableTab].value;
      let selected = Array.from(this.selected);
      vm.dialogUpdate = !checkData ? false : true;
      vm.loading = !checkData ? true : false;
      vm.creditorsImportDate = new Set();
      for (let i = 0; i < selected.length; i++) {
        if (checkData) {
          vm.creditorsImportDate.add(selected[i].creditor_id);
        } else {
          if (vm.archiveMultiple) selected[i].active = false;
          else
            selected[i].last_import_since = new Date(vm.last_import_since)
              .toISOString()
              .substr(0, 19);
          await strategyService
            .save(selected[i])
            .then((res) => {
              if (res == undefined) {
                console.error("houve um erro");
                vm.$store.commit("showSnackbar", "Houve um erro ao salvar");
              } else {
                updated++;
                selected[i] = res;
                if (vm.archiveMultiple) {
                  selected[i].selected = false;
                  this.selected = selected.filter((obj) => {
                    return obj.id !== selected[i].id;
                  });
                  vm.allStrategies[currentTab].data = vm.allStrategies[
                    currentTab
                  ].data.filter((obj) => {
                    return obj.id !== selected[i].id;
                  });
                } else {
                  selected[i].selected = true;
                }
              }
            })
            .catch((error) => {
              console.error("Houve um erro", error);
              vm.$store.commit("showSnackbar", "Houve um erro ao salvar");
              error++;
            });
        }
      }
      if (checkData) {
        vm.tabs = 1;
      } else {
        console.info("error: ", error, "ok: ", updated);
        vm.loading = false;
        let message = "";
        if (vm.archiveMultiple) {
          message =
            updated == 1
              ? `${updated} estratégia foi arquivada.`
              : `${updated} estratégias foram arquivadas.`;
        } else {
          message = `Data de importação atualizada em ${updated} `;
          message += updated > 1 ? `estratégias.` : "estratégia.";
        }
        vm.$store.commit("showSnackbar", {
          message,
          important: true,
        });
      }
    },
    fetchAll() {
      this.changeFilter();
      this.addfilters();
      this.getDataApi();
    },
    getDataApi() {
      if (this.loading) return;
      this.loading = true;
      let currentTab = this.publicTabs[this.tableTab].value;
      setTimeout(() => {
        strategyService
          .listAll(
            this.selectedCreditor,
            true,
            currentTab,
            false,
            this.selectedApproachTypes,
            false,
            "MANUAL"
          )
          .then((res) => {
            this.allStrategies[currentTab].data = res.objects;
            this.allStrategies[currentTab].fetched = true;
            this.allStrategies[currentTab].pagination.rowsPerPage = 999;
            this.allStrategies[currentTab].pagination.sortBy = "updated_at";
            this.allStrategies[currentTab].pagination.descending = true;
            this.createStrategySegment(currentTab);
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit(
              "showSnackbar",
              "Houve um erro ao buscar os dados"
            );
          })
          .finally(() => {
            this.loading = false;
          });
      }, 500);
    },
    addfilters() {
      this.query = {};
      this.query.tableTab = this.tableTab;
      if (this.selectedCreditor > 0)
        this.query.creditor = this.selectedCreditor;
      if (this.selectedApproachTypes.length) {
        this.query.approachTypes = this.selectedApproachTypes
          .map((sp) => sp)
          .join(",");
      }
      this.$store.commit("setManualStrategy", this.query);
      if (this.$route.path == "/strategies/production") {
        this.$router.push({
          name: "Sob demanda",
          query: this.query,
        });
      }
    },
    createStrategySegment(tab) {
      let vm = this;
      let days, debts, debtType, discounts, potentials, notifications;

      vm.allStrategies[tab].data.forEach((str) => {
        str.value_type = str.value_type ? str.value_type : "PRINCIPAL";
        days = "";
        debts = "";
        potentials = "";
        discounts = "";
        notifications = "";

        // dias de atraso
        if (str.min_days_of_delay && str.max_days_of_delay)
          days = `Atraso (${numeral(str.min_days_of_delay).format(
            "0,0"
          )} até ${numeral(str.max_days_of_delay).format("0,0")} dias)`;
        else if (str.max_days_of_delay)
          days = `Atraso (até ${numeral(str.max_days_of_delay).format(
            "0,0"
          )} dias)`;
        else if (str.min_days_of_delay)
          days = `Atraso (à partir de ${numeral(str.min_days_of_delay).format(
            "0,0"
          )} dias)`;
        else days = "Qualquer atraso";
        // tipo de valor
        debtType = str.value_type.substr(0, 1);
        if (debtType == "B") debtType = "V.contábil";
        else if (debtType == "N") debtType = "VP";

        if (str.min_debit && str.max_debit)
          debts = `${debtType} (R$${numeral(str.min_debit).format(
            "0,0[.]00"
          )} até R$${numeral(str.max_debit).format("0,0[.]00")})`;
        else if (str.max_debit)
          debts = `${debtType} (até R$${numeral(str.max_debit).format(
            "0,0[.]00"
          )} )`;
        else if (str.min_debit)
          debts = `${debtType} (à partir de R$${numeral(str.min_debit).format(
            "0,0[.]00"
          )} )`;
        else debts = "Qualquer valor";

        str.segmentString = days;
        str.segmentString2 = debts;

        if (str.min_discount && str.max_discount)
          discounts = `Desconto (${numeral(str.min_discount).format(
            "0.[00]%"
          )} até ${numeral(str.max_discount).format("0.[00]%")})`;
        else if (str.max_discount)
          discounts = `Desconto (até ${numeral(str.max_discount).format(
            "0.[00]%"
          )})`;
        else if (str.min_discount)
          discounts = `Desconto (à partir de ${numeral(str.min_discount).format(
            "0.[00]%"
          )})`;
        else discounts = "Qualquer desconto";

        if (str.min_potential && str.max_potential)
          potentials = `Potencial (R$${numeral(str.min_potential).format(
            "0,0[.]00"
          )} até R$${numeral(str.max_potential).format("0,0[.]00")})`;
        else if (str.max_potential)
          potentials = `Potencial (até R$${numeral(str.max_potential).format(
            "0,0[.]00"
          )} )`;
        else if (str.min_potential)
          potentials = `Potencial (à partir de R$ ${numeral(
            str.min_potential
          ).format("0,0[.]00")} )`;
        else potentials = "Qualquer potencial";

        str.segmentString3 = discounts;
        str.segmentString4 = potentials;
      });
    },
    publishSelected() {
      let published = 0;
      this.loading = true;
      this.selected.forEach((item) => {
        this.publish(item, false);
        published++;
      });
      this.loading = false;
      if (published) {
        let message = ``;
        if (published == 1)
          message = `${published} estratégia publicada com sucesso!`;
        else message = `${published} estratégias publicadas com sucesso!`;
        this.$store.commit("showSnackbar", {
          message: message,
          important: true,
        });
        this.getDataApi();
      }
    },
    async publish(item, answer = true) {
      item.workspace = "MANUAL";
      await strategyService
        .save(item)
        .then(async (res) => {
          if (answer) {
            if (res == undefined) {
              this.$store.commit("showSnackbar", "Houve um erro ao salvar");
              return console.error("houve um erro");
            } else {
              let message = `Estratégia ${item.name} publicada!`;
              this.$store.commit("showSnackbar", {
                message,
                important: true,
              });
              this.getDataApi();
            }
          }
        })
        .catch((error) => {
          this.$store.commit("showSnackbar", "Houve um erro ao salvar");
          console.error("Houve um erro", error);
        });
    },
    notifySelected(test = false) {
      if (test) {
        let proceed = true;

        this.selected.forEach((item) => {
          if (item.approach.type != "SMS") proceed = false;
        });

        if (!proceed) {
          this.$store.commit(
            "showSnackbar",
            "Existe alguma abordagem com o tipo diferente de SMS!"
          );
          return;
        }
      }
      if (Cookies.get("miniDialog") == "true") {
        this.$store.commit(
          "showSnackbar",
          "Já existem um processo em andamento!"
        );
      } else {
        EventBus.$emit("notify", true, this.selected, true, test);
      }
    },
    hasTag(item) {
      let tags_v2 = item.tags_v2 != null ? item.tags_v2.length : 0;
      let contact_tags_v2 =
        item.contact_tags_v2 != null ? item.contact_tags_v2.length : 0;
      if (!tags_v2 && !contact_tags_v2) return false;
      return true;
    },
    checkNotificationToday(date) {
      if (!date) return false;
      let value = date.includes("Z") ? new Date(date) : new Date(date + "Z");
      let _diff = moment().isSame(moment.utc(value).local(), "day");
      return _diff;
    },
    changeFilter() {
      Object.keys(this.allStrategies).forEach((tab) => {
        this.allStrategies[tab] = {
          fetched: false,
          data: [],
          pagination: {},
          selected: [],
        };
      });
    },
    orderTags(dealTags, contactTags, customerTags) {
      let tags = [];
      if (dealTags && dealTags.length) {
        dealTags.split(",").forEach((e) => {
          tags.push({
            text: e,
            color: "dark-yellow",
            tooltip: "Tag de negócio",
          });
        });
      }
      if (contactTags && contactTags.length) {
        contactTags.split(",").forEach((e) => {
          tags.push({
            text: e,
            color: "blue",
            tooltip: "Tag de contato",
          });
        });
      }
      if (customerTags && customerTags.length) {
        customerTags.split(",").forEach((e) => {
          tags.push({
            text: e,
            color: "blue",
            tooltip: "Tag de cliente",
          });
        });
      }
      return tags;
    },
    saveMetrics() {
      this.arrayMetrics = [];
      Object.keys(this.metrics).forEach((k) => {
        if (this.metrics[k] == "") this.metrics[k] = null;
      });
      if (!this.multipleMetrics) {
        this.arrayMetrics.push(this.metrics);
      } else {
        this.selected.forEach((item) => {
          this.arrayMetrics.push({
            id: item.id,
            indicator_good_accessed: this.metrics.indicator_good_accessed,
            indicator_good_cpp: this.metrics.indicator_good_cpp,
            indicator_bad_implantation: this.metrics.indicator_bad_implantation,
            indicator_good_interest: this.metrics.indicator_good_interest,
            indicator_bad_accessed: this.metrics.indicator_bad_accessed,
            indicator_bad_cpp: this.metrics.indicator_bad_cpp,
            indicator_good_implantation:
              this.metrics.indicator_good_implantation,
            indicator_bad_interest: this.metrics.indicator_bad_interest,
          });
        });
        this.dialogMetrics = false;
        this.dialogMultipleMetrics = true;
      }
      this.arrayMetrics.forEach((item) => {
        strategyService
          .save(item)
          .then((res) => {
            if (!this.multipleMetrics) {
              if (res == undefined) {
                console.error("houve um erro");
                this.$store.commit("showSnackbar", {
                  message: "Houve um erro ao salvar",
                });
              } else {
                this.dialogMetrics = false;
                this.form = res;
                this.$store.commit("showSnackbar", {
                  message: "Estratégia salva com sucesso!",
                  important: true,
                });
                this.fetchAll();
              }
            } else {
              this.countMetrics += 1;
              if (this.countMetrics == this.arrayMetrics.length) {
                this.multipleMetrics = false;
                this.form = res;
                this.$store.commit("showSnackbar", {
                  message: "Estratégias salvas com sucesso!",
                  important: true,
                });
                this.fetchAll();
                this.selected = [];
                this.dialogMultipleMetrics = false;
              }
            }
          })
          .catch((error) => {
            this.$store.commit("showSnackbar", {
              message: "Houve um erro ao salvar",
            });
            console.error("Houve um erro", error);
          });
      });
      this.countMetrics = 0;
    },
    async clickItemAction(item, action) {
      let obg = Object.assign({}, item);
      if (action == "edit") {
        EventBus.$emit("edit", obg);
      } else if (action == "notify") {
        EventBus.$emit("notify", true, item);
      } else if (action == "clone") {
        delete obg.id;
        EventBus.$emit("edit", obg);
      } else if (action == "updateStatus") {
        await this.updateStrategyStatus(item);
      }
    },
    openDialogMetrics(item) {
      this.multipleMetrics = false;
      this.metrics = {
        id: item.id,
        name: item.name,
        indicator_good_accessed: item.indicator_good_accessed,
        indicator_good_cpp: item.indicator_good_cpp,
        indicator_bad_implantation: item.indicator_bad_implantation,
        indicator_good_interest: item.indicator_good_interest,
        indicator_bad_accessed: item.indicator_bad_accessed,
        indicator_bad_cpp: item.indicator_bad_cpp,
        indicator_good_implantation: item.indicator_good_implantation,
        indicator_bad_interest: item.indicator_bad_interest,
      };
      this.dialogMetrics = true;
    },
    cloneStrategy(strategy) {
      let vm = this;
      this.$router.push({
        name: "Estratégia",
        params: {
          edit: false,
          strategy_id: "new",
          selectedStrategy: strategy,
          query: vm.query,
        },
      });
    },
    editStrategy(strategy) {
      let vm = this;
      this.$router.push({
        name: "Estratégia",
        params: {
          page: "Sob demanda",
          edit: true,
          selectedStrategy: strategy,
          strategy_id: strategy.id,
          query: vm.query,
        },
      });
    },
    changeTable(item) {
      this.selected = [];
      Object.keys(this.allStrategies).forEach((tab) => {
        this.selected = this.selected.concat(this.allStrategies[tab].selected);
      });
    },
    deSelectAll() {
      this.selected = [];
      Object.keys(this.allStrategies).forEach((tab) => {
        this.allStrategies[tab].selected = [];
      });
    },
    goToApproach(approach) {
      this.$router.push({
        name: "Abordagem",
        params: {
          edit: true,
          approach_id: approach.id,
        },
      });
    },
    updateStrategies(tab) {
      this.allStrategies[tab].fetched = false;
      let currentTab = this.publicTabs[this.tableTab].value;
      if (currentTab == tab) {
        this.fetchAll(tab);
      }
    },
  },
};
</script>
<style></style>
